import React, { SVGProps } from 'react';

const DiceOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 26 25"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<g clipPath="url(#clip0_26992_149001)">
				<path
					d="M17.5287 1.30564L9.39352 4.943C8.55109 5.31966 8.17422 6.30863 8.55176 7.15194L12.1976 15.2956C12.5751 16.1389 13.5641 16.5172 14.4065 16.1406L22.5417 12.5032C23.3842 12.1265 23.761 11.1376 23.3835 10.2943L19.7377 2.15057C19.3601 1.30727 18.3712 0.928975 17.5287 1.30564Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.9961 8.02188C13.4173 7.83354 13.6057 7.33906 13.417 6.9174C13.2282 6.49575 12.7337 6.3066 12.3125 6.49494C11.8913 6.68327 11.7028 7.17775 11.8916 7.59941C12.0804 8.02106 12.5749 8.21021 12.9961 8.02188Z"
					fill="currentColor"
				/>
				<path
					d="M16.3086 9.48672C16.7298 9.29839 16.9182 8.8039 16.7295 8.38225C16.5407 7.96059 16.0462 7.77145 15.625 7.95978C15.2038 8.14811 15.0153 8.6426 15.2041 9.06425C15.3929 9.4859 15.8874 9.67505 16.3086 9.48672Z"
					fill="currentColor"
				/>
				<path
					d="M19.623 10.9555C20.0442 10.7671 20.2327 10.2726 20.0439 9.851C19.8551 9.42934 19.3606 9.2402 18.9394 9.42853C18.5182 9.61686 18.3298 10.1113 18.5186 10.533C18.7073 10.9547 19.2018 11.1438 19.623 10.9555Z"
					fill="currentColor"
				/>
				<path
					d="M7.25447 15.9699C7.72616 15.9699 8.10855 15.5875 8.10855 15.1158C8.10855 14.6441 7.72616 14.2617 7.25447 14.2617C6.78277 14.2617 6.40039 14.6441 6.40039 15.1158C6.40039 15.5875 6.78277 15.9699 7.25447 15.9699Z"
					fill="currentColor"
				/>
				<path
					d="M7.25447 21.091C7.72616 21.091 8.10855 20.7086 8.10855 20.2369C8.10855 19.7652 7.72616 19.3828 7.25447 19.3828C6.78277 19.3828 6.40039 19.7652 6.40039 20.2369C6.40039 20.7086 6.78277 21.091 7.25447 21.091Z"
					fill="currentColor"
				/>
				<path
					d="M9.81599 18.5324C10.2877 18.5324 10.6701 18.15 10.6701 17.6783C10.6701 17.2066 10.2877 16.8242 9.81599 16.8242C9.3443 16.8242 8.96191 17.2066 8.96191 17.6783C8.96191 18.15 9.3443 18.5324 9.81599 18.5324Z"
					fill="currentColor"
				/>
				<path
					d="M12.3785 21.091C12.8502 21.091 13.2326 20.7086 13.2326 20.2369C13.2326 19.7652 12.8502 19.3828 12.3785 19.3828C11.9068 19.3828 11.5244 19.7652 11.5244 20.2369C11.5244 20.7086 11.9068 21.091 12.3785 21.091Z"
					fill="currentColor"
				/>
				<path
					d="M13.9584 16.2035C13.1888 16.5158 12.1738 16.2035 11.75 15.2332L10.3 11.4141H5.26089C4.3175 11.4141 3.55273 12.1788 3.55273 13.1222V22.2324C3.55273 23.1758 4.3175 23.9405 5.26089 23.9405H14.3711C15.3144 23.9405 16.0792 23.1758 16.0792 22.2324L15.9972 15.4206L13.9584 16.2035Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_26992_149001">
					<rect
						width="25"
						height="25"
						fill="white"
						transform="translate(0.75)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default DiceOutlineIcon;
